import { render, staticRenderFns } from "../businessIntelligence/businessIntelligence.html?vue&type=template&id=17d1efa8&scoped=true&external"
import script from "../businessIntelligence/businessIntelligence.js?vue&type=script&lang=js&external"
export * from "../businessIntelligence/businessIntelligence.js?vue&type=script&lang=js&external"
import style0 from "../businessIntelligence/businessIntelligence.css?vue&type=style&index=0&id=17d1efa8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d1efa8",
  null
  
)

export default component.exports